import { TypedUseSelectorHook, useDispatch as originalDispatch, useSelector as originalSelector } from 'react-redux'
import store, { StateModel } from './store'

export type Dispatch = typeof store.dispatch;

// Use throughout your app instead of plain `useDispatch` and `useSelector`
export const useDispatch = () => originalDispatch<Dispatch>()
export const useSelector: TypedUseSelectorHook<StateModel> = originalSelector